import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import './typography.css'

const P = ({ children, className }) => <p className={cn('P', className)}>{children}</p>

P.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
}

export default P
